import React, { FC } from "react";
import { IWizardStepContent } from "../../../../wizard/types";
import { Accordions, DetailImages } from "../../components";

const Content: FC<IWizardStepContent> = ({ stepName }) => (
  <>
    <Accordions fieldsGroupName={stepName} />
    <DetailImages fieldsGroupName={stepName} />
  </>
);

export default Content;
